// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1__WF","footer":"styles_footer__13IWp","passCodeTooltip":"styles_passCodeTooltip__SP1fh"};